import { connect } from 'react-redux';
import { getVillageId, getCountrysideBuilderLandingPromoData } from '../../selectors';
import { IState } from '../../store';
import {
  AsideTipCountrysideBuilderPromo,
  IAsideTipCountrysideBuilderPromoProps,
} from './AsideTipCountrysideBuilderPromo';

export function mapStateToProps(state: IState): IAsideTipCountrysideBuilderPromoProps {
  const villageId = getVillageId(state);

  return {
    offerId: state.offerData.offer.id,
    data: villageId ? getCountrysideBuilderLandingPromoData(state, villageId) : null,
  };
}

export const AsideTipCountrysideBuilderPromoContainer = connect<IAsideTipCountrysideBuilderPromoProps>(mapStateToProps)(
  AsideTipCountrysideBuilderPromo,
);
